export default __webpack_public_path__ + "c8475f68c4933f0778a431cb4636802e.webp";